import { createContext } from 'react';

import { ModalMode } from '@app-velocity/message-bus';

export type ModalWrapperContextType = {
  openModal: (id: string) => void;
  closeModal: () => void;
  setModalData: (modalId: string, data: unknown) => void;
  setMode: (mode: ModalMode) => void;
  setClosable: (closable: boolean) => void;
  openedModalId: string;
  isWrapperVisible: boolean;
  modalData: Record<string, unknown>;
  mode: ModalMode;
  closable: boolean;
};

export const ModalWrapperContext = createContext<ModalWrapperContextType>({
  openModal: (id: string) => null,
  closeModal: () => null,
  setModalData: (modalId: string, data: unknown) => null,
  setMode: (mode: ModalMode) => null,
  setClosable: (closable: boolean) => null,
  openedModalId: '',
  isWrapperVisible: false,
  modalData: {},
  mode: 'default',
  closable: true,
});
